import { render, staticRenderFns } from "./IconArrowUpSolid.vue?vue&type=template&id=e5bf6528"
import script from "./IconArrowUpSolid.vue?vue&type=script&lang=js"
export * from "./IconArrowUpSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports